// extracted by mini-css-extract-plugin
export var actions = "_16-0";
export var actionsContainer = "_16-6";
export var border = "_16-1";
export var childFullHeight = "_16-d";
export var collapse = "_16-2";
export var content = "_16-8";
export var contentChild = "_16-c";
export var fullscreen = "_16-a";
export var headerContainer = "_16-3";
export var headerRow = "_16-5";
export var hidePadding = "_16-9";
export var noScrollX = "_16-e";
export var noScrollY = "_16-f";
export var optOutTopPadding = "_16-b";
export var pagePadding = "_16-7";
export var profile = "_16-g";
export var profileContainer = "_16-h";
export var profileImage = "_16-i";
export var profileMain = "_16-j";
export var profileSubtitle = "_16-l";
export var profileTitle = "_16-k";
export var tabsWrapper = "_16-4";
export var title = "_16-m";